module.exports = "<mat-form-field class=\"search\"  [ngClass]=\"{'search-open': open == true}\"> \r\n  <input matInput placeholder=\"Search\" autocomplete=\"off\" (focus)=\"bigMenu = true\" (focusout)=\"bigMenu = false\">\r\n</mat-form-field>"


//////////////////
// WEBPACK FOOTER
// E:/sree/New folder (3)/cdk-material-v2/src/app/core/search-bar/search-bar.component.html
// module id = ../../../../../src/app/core/search-bar/search-bar.component.html
// module chunks = main